<template>
<div>
  <div class='notification'>
    <div class='icon-cont'>
      <i class='fas fa-plus-square'></i>
    </div>
    <div class='body-cont'>
      <span>No sessions have been added yet. <br> <a href='#'>Click Here</a> to get started.</span>
      <i class='fas fa-eye'></i>
    </div>
  </div>

  <div class='notification'>
    <div class='icon-cont'>
      <i class='fas fa-plus-square'></i>
    </div>
    <div class='body-cont'>
      <span>No sessions have been added yet. <br> <a href='#'>Click Here</a> to get started.</span>
      <i class='fas fa-eye'></i>
    </div>
  </div>

  <div class='notification'>
    <div class='icon-cont'>
      <i class='fas fa-plus-square'></i>
    </div>
    <div class='body-cont'>
      <span>No sessions have been added yet. <br> <a href='#'>Click Here</a> to get started.</span>
      <i class='fas fa-eye'></i>
    </div>
  </div>

</div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped lang='scss'>
.notification {
  background: $gray-5;
  margin: 18px 0px;
  border-radius: 4px;
  min-height: 60px;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  box-shadow: 0 0 2px rgba(34, 25, 25, 0.6);

  .icon-cont {
    color: $gray-5;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.9rem;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    width: 60px;
    background: $primary;
  }
  .body-cont {
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    line-height: 120%;
    color: $primary;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notificationList.vue